import React from 'react';
import Header from '../../Header/Header';
import css from '../Signin.module.css';

const UnAuthorizedUser = (props) => {
    return (
        <div>
            <Header />
            <br />
            <br />
            <div className={css.error}>
                You are not authorized to view this feature. Kindly contact your{' '}
                <b>administrator</b>
            </div>
        </div>
    );
};

export default UnAuthorizedUser;
